import axios from "axios";
import { SignupRequestModel } from "./Models/SignupRequestModel";

export class SignUpAPI {
	public static async SignUp(userName: string, password: string, firstName: string) {
		return (await axios.post("/api/signup", new SignupRequestModel(userName, password, firstName))).data;
	}
}
